import { createContext } from "react";
import { ExternalNavigationContextObject } from "./external-navigate";

export const websiteContext = createContext<ExternalNavigationContextObject>(null!);

export const signupContext = createContext<ExternalNavigationContextObject>(null!);
